import './App.css'

import React, { Suspense } from 'react'

import LoadingPage from '../components/LoadingPage'
import Routes from './Routes'

const App = () => (
  <div className='app'>
    <Suspense fallback={<LoadingPage />}>
      <Routes />
    </Suspense>
  </div>
)

export default App
